import React, {Component} from 'react';
import '../../App.css';
// import {TableColumnPopupType} from '../Popup/TableColumnPopup';
// import { getLocalisedText } from '../../Translate/LanguageManager';
// import AppManager from '../../Manager/AppManager';
// import Utility from '../../Utilities/Utility';

import {
    Utility,
    AppManager,
    getLocalisedText,
    TableColumnPopupType
} from 'deskera-doc-builder-lib';
export default class ProductColumnEditor extends Component {

    dataChanged(data) {
        this.props.dataChanged(this.props.data);
    }

    render() {
        return this.getProductColumns(this.props.columnData)
    }

    getProductColumns(columnsData = []) {
        var arr = [];
        for (let i = 0; i < columnsData.length; i++) {
            arr.push(this.getProductColumn(i, columnsData[i]));
        }
        return arr;
    }

    getProductColumn(index, columnData) {
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    alignItems: "flex-start",
                }}
            >

                {this.getShowHideValueForTablePopup(TableColumnPopupType.productName) && this.getColumnTextfields(
                    "item_name",
                    index,
                    columnData.name,
                    this.columnNameChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.description) && this.getColumnTextfields(
                    "item_description",
                    index,
                    columnData.description,
                    this.columnDescriptionChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.quantity) && this.getColumnTextfields(
                    "qty",
                    index,
                    columnData.quantity,
                    this.columnQuantityChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.unitPrice) && this.getColumnTextfields(
                    "unit_price",
                    index,
                    columnData.unitPrice,
                    this.columnUnitPriceChanged
                )}

                {this.getShowHideValueForTablePopup(TableColumnPopupType.discount) && this.getColumnTextfields(
                    getLocalisedText("discount") + " (%)",
                    index,
                    columnData.discount,
                    this.columnDiscountChanged
                )}

                {this.getShowHideValueForTablePopup(TableColumnPopupType.tax) && this.getColumnTextfields(
                    getLocalisedText("tax") + " (%)",
                    index,
                    columnData.tax,// + (columnData.tax !== "" ? '%' : ""),
                    this.columnTaxChanged
                )}

                <div className='RowDiv'
                    style={{
                        flexDirection: Utility.getIsArabicLang() ? 'row-reverse' : 'row'
                    }}>
                    <button
                        style={{
                            marginTop: 10,
                            cursor: "pointer",
                            color: "red",
                            border: "solid",
                            borderWidth: 1,
                            borderColor: "rgb(210, 210, 210)",
                            backgroundColor: "white",
                            borderRadius: 4,
                            marginBottom: 20,
                        }}
                        onClick={() => this.deleteColumn(index)}
                    >
                        {getLocalisedText("delete")}
                    </button>
                </div>
            </div>
        );
    }

    deleteColumn(index) {
        var data = this.props.data;
        data["lineItems"].splice(index, 1);
        this.dataChanged(data);
    }

    getColumnTextfields(placeholder, index, value, callback) {
        return (
            <input
                className="TextField"
                style={{
                    marginTop: 6,
                    borderRadius: 4,
                    color: 'rgb(30, 30, 30)'
                }}
                placeholder={getLocalisedText(placeholder)}
                type="text"
                dir={Utility.getInputDirection()}
                value={getLocalisedText(value)}
                onChange={(e) => callback(e, index)}
            />
        );
    }

    columnNameChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["name"] = event.target.value;
        this.dataChanged(data);
    };
    columnDescriptionChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["description"] = event.target.value;
        this.dataChanged(data);
    };

    columnQuantityChanged = (event, index) => {
        let value = event.target.value
        if (isNaN(value)) {
            return
        }
        var data = this.props.data;
        data["lineItems"][index]["quantity"] = value;
        this.dataChanged(data);
    };
    columnUnitPriceChanged = (event, index) => {
        let value = event.target.value
        if (isNaN(value)) {
            return
        }

        var data = this.props.data;
        data["lineItems"][index]["unitPrice"] = value;
        this.dataChanged(data);
    };
    columnDiscountChanged = (event, index) => {
        let value = event.target.value
        if (value.length > 3 || isNaN(value)) {
            return
        }
        var data = this.props.data;
        data["lineItems"][index]["discount"] = value;
        this.dataChanged(data);
    };
    columnTaxChanged = (event, index) => {
        let value = event.target.value
        // let valWithoutPercent = value.replace("%","")
        if (value.length > 3 || isNaN(value)) {
            return
        }
        var data = this.props.data;
        data["lineItems"][index]["tax"] = value;
        this.dataChanged(data);
    };

    getShowHideValueForTablePopup(tableColumnPopupType) {
        var item = AppManager.getTableColumnOptions(this.props.data.tableColumnPopup, tableColumnPopupType)
        if(item === undefined || item  === null) {
            return false
        }
        else {
            return item.isSelected
        }
    }

}
